import { useEffect, useState } from "react";
import { LogoGlyph } from "./logo-glyph";

const INTRO_KEY = "anivora.intro.v1";
const INTRO_MS = 1_500;

function shouldShowIntro(): boolean {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
  try {
    return window.sessionStorage.getItem(INTRO_KEY) !== "seen";
  } catch {
    return true;
  }
}

/** A brief brand reveal once per browser tab session. */
export function BrandIntro() {
  const [visible, setVisible] = useState(shouldShowIntro);

  useEffect(() => {
    if (!visible) return;
    try {
      window.sessionStorage.setItem(INTRO_KEY, "seen");
    } catch {
      // The intro still ends on time when session storage is unavailable.
    }
    const timer = window.setTimeout(() => setVisible(false), INTRO_MS);
    return () => window.clearTimeout(timer);
  }, [visible]);

  if (!visible) return null;
  return (
    <div className="brand-intro" role="status" aria-label="Anivora">
      <div className="brand-intro__lockup">
        <span className="brand-intro__mark"><LogoGlyph className="size-10" /></span>
        <span className="brand-intro__name">Anivora</span>
        <span className="brand-intro__rule" />
      </div>
    </div>
  );
}
